import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MapSettingsDialog } from '../map-settings/map-settings.dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component'

import { AuthService } from 'src/app/user/services/auth.service';
import { SettingService } from '../services/setting.service';
import { FileDataService } from '../components/services/file-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  mapSettingsData:Array<any> = [];
  constructor(
    private router:Router,
    private settingsDialog:MatDialog,
    private confirmDialog:MatDialog,
    private settingsService:SettingService,
    private authService:AuthService,
    private fileDataServices:FileDataService) { }

  ngOnInit(): void {
    const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if(storedUser != null) {
      const userId = storedUser.userId;
      this.settingsService.getMapSettings(userId).subscribe(
        (res:any) => {
          if(res.responseStatus === 'Success' ) {
            this.settingsService.changeLocalMapSettings(res.responseData);
          } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
            this.authService.logout();
            this.router.navigate(['/user/login']);
          }
        },
        err => console.log('Error while Map Dropdown values:', err)
      );
    }
  }
  
  openSettingsDialog():void{
    this.settingsDialog.open(MapSettingsDialog, {
      width: '30rem',
      disableClose :true,
    });
  }
  logout():void{
    let message:string;
    let width:string;
    if(this.fileDataServices.isItinerayChanged){
      message = "Changes will be lost. Continue anyway?";
      width = "28rem";
    }
    else{
      message = "Are you sure you want to logout?";
      width = "25rem";
    }
    const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
      width,
      data : message,
      disableClose :false
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result.saveData){
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } 
    })
    
  }
 
}
